export const LANGCHAIN_INTEGRATION_NAME = 'LangChain';
export const LANGCHAIN_ORIGIN = 'auto.ai.langchain';

export const ROLE_MAP: Record<string, string> = {
  human: 'user',
  ai: 'assistant',
  assistant: 'assistant',
  system: 'system',
  function: 'function',
  tool: 'tool',
};
